import { memo } from 'react';
import { motion } from 'framer-motion';
import { Box, VStack } from '@chakra-ui/react';

import { useHeaderBoundStore } from 'app/selectors';
import { isEmptyObject } from 'shared/lib/isEmptyObject';

import { menuToggleVariants } from 'constants/header';

const MenuToggle = ({ isCulturalCode = false, ...props }) => {
  const {
    isLight,
    isOverlapsFooter,
    setIsLight,
    headerMenuData,
    updateHeaderMenuState,
    updateHeaderMenuData,
  } = useHeaderBoundStore();
  const isHeaderMenuDataFully = !isEmptyObject(headerMenuData);

  return (
    <VStack
      boxSize="32px"
      cursor="pointer"
      justify="space-between"
      zIndex="1100"
      onClick={() => {
        updateHeaderMenuState('toggle');
        isHeaderMenuDataFully && updateHeaderMenuData('reset');
        isOverlapsFooter && setIsLight(!isLight);
      }}
      {...props}
    >
      <Box
        as={motion.svg}
        w="full"
        h="full"
        pl="2px"
        pt="5px"
        viewBox="0 0 23 23"
        objectFit="cover"
        stroke={`text.${isCulturalCode ? 'white' : isLight ? 'white' : 'black'}`}
        transition="all .2s linear"
      >
        {menuToggleVariants?.map((val, i) => (
          <Path key={i} {...val} />
        ))}
      </Box>
    </VStack>
  );
};

const Path = props => (
  <Box as={motion.path} fill="transparent" strokeWidth="2" strokeLinecap="round" {...props} />
);

export default memo(MenuToggle);
